<div class="modal-header text-center">
    <div class="d-flex align-items-start">
        <div class="mr-auto">
            <h3 class="modal-title" id="modal-title">{{ headline }}</h3>
        </div>
    </div>
</div>
<div class="modal-body pb-5 text-multiline" id="modal-body">
    <span id="copy-this">{{ resolve.copyString }}</span>
    <mon-copy class="pull-right" target="copy-this"></mon-copy>
</div>
<div class="modal-footer text-left">
    <button class="btn btn-primary" (click)="close()" translate>Close</button>
</div>
